// Bitelyze i18n — lightweight translation module
// Free: translations generated by Claude during dev session, no runtime API cost.
// AI coach is multilingual via the same Claude API call — passing lang to /api/coach
// makes the assistant respond in the user's chosen language.

export const LANGUAGES = [
  { code: "en", name: "English",        native: "English",          flag: "🇺🇸" },
  { code: "es", name: "Spanish",        native: "Español",          flag: "🇪🇸" },
  { code: "fr", name: "French",         native: "Français",         flag: "🇫🇷" },
  { code: "pt", name: "Portuguese",     native: "Português",        flag: "🇵🇹" },
  { code: "de", name: "German",         native: "Deutsch",          flag: "🇩🇪" },
  { code: "it", name: "Italian",        native: "Italiano",         flag: "🇮🇹" },
  { code: "nl", name: "Dutch",          native: "Nederlands",       flag: "🇳🇱" },
  { code: "ru", name: "Russian",        native: "Русский",          flag: "🇷🇺" },
  { code: "tr", name: "Turkish",        native: "Türkçe",           flag: "🇹🇷" },
  { code: "ar", name: "Arabic",         native: "العربية",          flag: "🇸🇦" },
  { code: "hi", name: "Hindi",          native: "हिन्दी",            flag: "🇮🇳" },
  { code: "zh", name: "Chinese",        native: "中文",             flag: "🇨🇳" },
  { code: "ja", name: "Japanese",       native: "日本語",           flag: "🇯🇵" },
  { code: "ko", name: "Korean",         native: "한국어",           flag: "🇰🇷" },
  { code: "id", name: "Indonesian",     native: "Bahasa Indonesia", flag: "🇮🇩" },
  { code: "tl", name: "Filipino",       native: "Filipino",         flag: "🇵🇭" },
  { code: "sw", name: "Swahili",        native: "Kiswahili",        flag: "🇰🇪" },
  { code: "yo", name: "Yoruba",         native: "Yorùbá",           flag: "🇳🇬" },
  { code: "ig", name: "Igbo",           native: "Igbo",             flag: "🇳🇬" },
  { code: "ha", name: "Hausa",          native: "Hausa",            flag: "🇳🇬" },
];

// English-name labels used in the AI coach system prompt — Claude responds in this language.
export const LANG_PROMPT_NAME = {
  en: "English", es: "Spanish", fr: "French", pt: "Portuguese", de: "German",
  it: "Italian", nl: "Dutch", ru: "Russian", tr: "Turkish", ar: "Arabic",
  hi: "Hindi", zh: "Mandarin Chinese (Simplified)", ja: "Japanese", ko: "Korean",
  id: "Indonesian", tl: "Filipino (Tagalog)", sw: "Swahili", yo: "Yoruba",
  ig: "Igbo", ha: "Hausa",
};

// String dictionary. English is canonical; other languages override keys.
// Missing keys fall back to English automatically.
const STRINGS = {
  en: {
    "tab.analyze": "Analyze",
    "tab.log": "Log",
    "tab.progress": "Progress",
    "tab.coach": "Coach",
    "tab.more": "More",
    "common.continue": "Continue",
    "common.back": "Back",
    "common.save": "Save",
    "common.cancel": "Cancel",
    "common.done": "Done",
    "common.loading": "Loading…",
    "common.signOut": "Sign Out",
    "more.account": "Account",
    "more.app": "App",
    "more.features": "Features",
    "more.myProfile": "My Profile",
    "more.editGoals": "Edit Goals",
    "more.chatCoach": "Chat with Bitelyze Coach",
    "more.appearance": "Appearance",
    "more.notifications": "Notifications",
    "more.homeScreen": "Add to Home Screen",
    "more.language": "Language",
    "more.languageDesc": "Choose your preferred language. The AI coach will reply in the language you pick.",
    "plan.startTracking": "Start Tracking",
    "plan.settingUp": "Setting up your dashboard…",
    "plan.saveChanges": "Save Changes",
    "plan.saving": "Saving changes…",
    "coach.online": "Online",
    "coach.placeholder": "Ask your coach anything…",
    "coach.history": "Chat History",
  },
  es: {
    "tab.analyze": "Analizar",
    "tab.log": "Registro",
    "tab.progress": "Progreso",
    "tab.coach": "Entrenador",
    "tab.more": "Más",
    "common.continue": "Continuar",
    "common.back": "Atrás",
    "common.save": "Guardar",
    "common.cancel": "Cancelar",
    "common.done": "Listo",
    "common.loading": "Cargando…",
    "common.signOut": "Cerrar sesión",
    "more.account": "Cuenta",
    "more.app": "Aplicación",
    "more.features": "Funciones",
    "more.myProfile": "Mi perfil",
    "more.editGoals": "Editar objetivos",
    "more.chatCoach": "Chatea con Bitelyze",
    "more.appearance": "Apariencia",
    "more.notifications": "Notificaciones",
    "more.homeScreen": "Añadir a pantalla de inicio",
    "more.language": "Idioma",
    "more.languageDesc": "Elige tu idioma preferido. El entrenador IA responderá en el idioma que elijas.",
    "plan.startTracking": "Empezar a registrar",
    "plan.settingUp": "Preparando tu panel…",
    "plan.saveChanges": "Guardar cambios",
    "plan.saving": "Guardando…",
    "coach.online": "En línea",
    "coach.placeholder": "Pregúntale a tu entrenador…",
    "coach.history": "Historial de chats",
  },
  fr: {
    "tab.analyze": "Analyser",
    "tab.log": "Journal",
    "tab.progress": "Progrès",
    "tab.coach": "Coach",
    "tab.more": "Plus",
    "common.continue": "Continuer",
    "common.back": "Retour",
    "common.save": "Enregistrer",
    "common.cancel": "Annuler",
    "common.done": "Terminé",
    "common.loading": "Chargement…",
    "common.signOut": "Se déconnecter",
    "more.account": "Compte",
    "more.app": "Application",
    "more.features": "Fonctionnalités",
    "more.myProfile": "Mon profil",
    "more.editGoals": "Modifier les objectifs",
    "more.chatCoach": "Discuter avec Bitelyze",
    "more.appearance": "Apparence",
    "more.notifications": "Notifications",
    "more.homeScreen": "Ajouter à l'écran d'accueil",
    "more.language": "Langue",
    "more.languageDesc": "Choisissez votre langue préférée. Le coach IA répondra dans la langue choisie.",
    "plan.startTracking": "Commencer le suivi",
    "plan.settingUp": "Préparation du tableau de bord…",
    "plan.saveChanges": "Enregistrer les modifications",
    "plan.saving": "Enregistrement…",
    "coach.online": "En ligne",
    "coach.placeholder": "Posez une question à votre coach…",
    "coach.history": "Historique des conversations",
  },
  pt: {
    "tab.analyze": "Analisar",
    "tab.log": "Registro",
    "tab.progress": "Progresso",
    "tab.coach": "Treinador",
    "tab.more": "Mais",
    "common.continue": "Continuar",
    "common.back": "Voltar",
    "common.save": "Salvar",
    "common.cancel": "Cancelar",
    "common.done": "Pronto",
    "common.loading": "Carregando…",
    "common.signOut": "Sair",
    "more.account": "Conta",
    "more.app": "Aplicativo",
    "more.features": "Recursos",
    "more.myProfile": "Meu perfil",
    "more.editGoals": "Editar metas",
    "more.chatCoach": "Conversar com Bitelyze",
    "more.appearance": "Aparência",
    "more.notifications": "Notificações",
    "more.homeScreen": "Adicionar à tela inicial",
    "more.language": "Idioma",
    "more.languageDesc": "Escolha o seu idioma preferido. O treinador IA responderá no idioma escolhido.",
    "plan.startTracking": "Começar a registrar",
    "plan.settingUp": "Preparando o painel…",
    "plan.saveChanges": "Salvar alterações",
    "plan.saving": "Salvando…",
    "coach.online": "Online",
    "coach.placeholder": "Pergunte algo ao seu treinador…",
    "coach.history": "Histórico de conversas",
  },
  de: {
    "tab.analyze": "Analysieren",
    "tab.log": "Tagebuch",
    "tab.progress": "Fortschritt",
    "tab.coach": "Coach",
    "tab.more": "Mehr",
    "common.continue": "Weiter",
    "common.back": "Zurück",
    "common.save": "Speichern",
    "common.cancel": "Abbrechen",
    "common.done": "Fertig",
    "common.loading": "Lädt…",
    "common.signOut": "Abmelden",
    "more.account": "Konto",
    "more.app": "App",
    "more.features": "Funktionen",
    "more.myProfile": "Mein Profil",
    "more.editGoals": "Ziele bearbeiten",
    "more.chatCoach": "Mit Bitelyze chatten",
    "more.appearance": "Darstellung",
    "more.notifications": "Benachrichtigungen",
    "more.homeScreen": "Zum Startbildschirm hinzufügen",
    "more.language": "Sprache",
    "more.languageDesc": "Wähle deine bevorzugte Sprache. Der KI-Coach antwortet in der gewählten Sprache.",
    "plan.startTracking": "Tracking starten",
    "plan.settingUp": "Dashboard wird eingerichtet…",
    "plan.saveChanges": "Änderungen speichern",
    "plan.saving": "Wird gespeichert…",
    "coach.online": "Online",
    "coach.placeholder": "Frag deinen Coach…",
    "coach.history": "Chat-Verlauf",
  },
  it: {
    "tab.analyze": "Analizza",
    "tab.log": "Diario",
    "tab.progress": "Progressi",
    "tab.coach": "Coach",
    "tab.more": "Altro",
    "common.continue": "Continua",
    "common.back": "Indietro",
    "common.save": "Salva",
    "common.cancel": "Annulla",
    "common.done": "Fatto",
    "common.loading": "Caricamento…",
    "common.signOut": "Esci",
    "more.account": "Account",
    "more.app": "App",
    "more.features": "Funzionalità",
    "more.myProfile": "Il mio profilo",
    "more.editGoals": "Modifica obiettivi",
    "more.chatCoach": "Chatta con Bitelyze",
    "more.appearance": "Aspetto",
    "more.notifications": "Notifiche",
    "more.homeScreen": "Aggiungi alla schermata Home",
    "more.language": "Lingua",
    "more.languageDesc": "Scegli la tua lingua preferita. Il coach IA risponderà nella lingua scelta.",
    "plan.startTracking": "Inizia a tracciare",
    "plan.settingUp": "Preparazione della dashboard…",
    "plan.saveChanges": "Salva modifiche",
    "plan.saving": "Salvataggio…",
    "coach.online": "Online",
    "coach.placeholder": "Chiedi al tuo coach…",
    "coach.history": "Cronologia chat",
  },
  nl: {
    "tab.analyze": "Analyseren",
    "tab.log": "Logboek",
    "tab.progress": "Voortgang",
    "tab.coach": "Coach",
    "tab.more": "Meer",
    "common.continue": "Doorgaan",
    "common.back": "Terug",
    "common.save": "Opslaan",
    "common.cancel": "Annuleren",
    "common.done": "Klaar",
    "common.loading": "Laden…",
    "common.signOut": "Afmelden",
    "more.account": "Account",
    "more.app": "App",
    "more.features": "Functies",
    "more.myProfile": "Mijn profiel",
    "more.editGoals": "Doelen bewerken",
    "more.chatCoach": "Chat met Bitelyze",
    "more.appearance": "Weergave",
    "more.notifications": "Meldingen",
    "more.homeScreen": "Aan startscherm toevoegen",
    "more.language": "Taal",
    "more.languageDesc": "Kies je voorkeurstaal. De AI-coach antwoordt in de gekozen taal.",
    "plan.startTracking": "Beginnen met volgen",
    "plan.settingUp": "Dashboard wordt klaargemaakt…",
    "plan.saveChanges": "Wijzigingen opslaan",
    "plan.saving": "Opslaan…",
    "coach.online": "Online",
    "coach.placeholder": "Vraag je coach iets…",
    "coach.history": "Chatgeschiedenis",
  },
  ru: {
    "tab.analyze": "Анализ",
    "tab.log": "Журнал",
    "tab.progress": "Прогресс",
    "tab.coach": "Тренер",
    "tab.more": "Ещё",
    "common.continue": "Продолжить",
    "common.back": "Назад",
    "common.save": "Сохранить",
    "common.cancel": "Отмена",
    "common.done": "Готово",
    "common.loading": "Загрузка…",
    "common.signOut": "Выйти",
    "more.account": "Аккаунт",
    "more.app": "Приложение",
    "more.features": "Функции",
    "more.myProfile": "Мой профиль",
    "more.editGoals": "Изменить цели",
    "more.chatCoach": "Чат с Bitelyze",
    "more.appearance": "Оформление",
    "more.notifications": "Уведомления",
    "more.homeScreen": "Добавить на главный экран",
    "more.language": "Язык",
    "more.languageDesc": "Выберите предпочитаемый язык. ИИ-тренер ответит на выбранном языке.",
    "plan.startTracking": "Начать отслеживание",
    "plan.settingUp": "Настройка панели…",
    "plan.saveChanges": "Сохранить изменения",
    "plan.saving": "Сохранение…",
    "coach.online": "В сети",
    "coach.placeholder": "Спроси своего тренера…",
    "coach.history": "История чатов",
  },
  tr: {
    "tab.analyze": "Analiz",
    "tab.log": "Günlük",
    "tab.progress": "İlerleme",
    "tab.coach": "Koç",
    "tab.more": "Daha Fazla",
    "common.continue": "Devam et",
    "common.back": "Geri",
    "common.save": "Kaydet",
    "common.cancel": "İptal",
    "common.done": "Tamam",
    "common.loading": "Yükleniyor…",
    "common.signOut": "Çıkış yap",
    "more.account": "Hesap",
    "more.app": "Uygulama",
    "more.features": "Özellikler",
    "more.myProfile": "Profilim",
    "more.editGoals": "Hedefleri düzenle",
    "more.chatCoach": "Bitelyze ile sohbet et",
    "more.appearance": "Görünüm",
    "more.notifications": "Bildirimler",
    "more.homeScreen": "Ana ekrana ekle",
    "more.language": "Dil",
    "more.languageDesc": "Tercih ettiğiniz dili seçin. Yapay zeka koçu seçilen dilde yanıt verir.",
    "plan.startTracking": "Takibe başla",
    "plan.settingUp": "Panonuz hazırlanıyor…",
    "plan.saveChanges": "Değişiklikleri kaydet",
    "plan.saving": "Kaydediliyor…",
    "coach.online": "Çevrimiçi",
    "coach.placeholder": "Koçuna bir şey sor…",
    "coach.history": "Sohbet geçmişi",
  },
  ar: {
    "tab.analyze": "تحليل",
    "tab.log": "السجل",
    "tab.progress": "التقدم",
    "tab.coach": "المدرب",
    "tab.more": "المزيد",
    "common.continue": "متابعة",
    "common.back": "رجوع",
    "common.save": "حفظ",
    "common.cancel": "إلغاء",
    "common.done": "تم",
    "common.loading": "جارٍ التحميل…",
    "common.signOut": "تسجيل الخروج",
    "more.account": "الحساب",
    "more.app": "التطبيق",
    "more.features": "المزايا",
    "more.myProfile": "ملفي الشخصي",
    "more.editGoals": "تعديل الأهداف",
    "more.chatCoach": "محادثة مع Bitelyze",
    "more.appearance": "المظهر",
    "more.notifications": "الإشعارات",
    "more.homeScreen": "إضافة إلى الشاشة الرئيسية",
    "more.language": "اللغة",
    "more.languageDesc": "اختر لغتك المفضلة. سيرد المدرب الذكي بنفس اللغة.",
    "plan.startTracking": "ابدأ المتابعة",
    "plan.settingUp": "يتم إعداد لوحتك…",
    "plan.saveChanges": "حفظ التغييرات",
    "plan.saving": "جارٍ الحفظ…",
    "coach.online": "متصل",
    "coach.placeholder": "اسأل مدربك أي شيء…",
    "coach.history": "سجل المحادثات",
  },
  hi: {
    "tab.analyze": "विश्लेषण",
    "tab.log": "लॉग",
    "tab.progress": "प्रगति",
    "tab.coach": "कोच",
    "tab.more": "और",
    "common.continue": "जारी रखें",
    "common.back": "वापस",
    "common.save": "सेव करें",
    "common.cancel": "रद्द करें",
    "common.done": "हो गया",
    "common.loading": "लोड हो रहा है…",
    "common.signOut": "साइन आउट",
    "more.account": "अकाउंट",
    "more.app": "ऐप",
    "more.features": "विशेषताएँ",
    "more.myProfile": "मेरा प्रोफाइल",
    "more.editGoals": "लक्ष्य बदलें",
    "more.chatCoach": "Bitelyze कोच से बात करें",
    "more.appearance": "रूप-रंग",
    "more.notifications": "सूचनाएं",
    "more.homeScreen": "होम स्क्रीन में जोड़ें",
    "more.language": "भाषा",
    "more.languageDesc": "अपनी पसंदीदा भाषा चुनें। AI कोच उसी भाषा में जवाब देगा।",
    "plan.startTracking": "ट्रैकिंग शुरू करें",
    "plan.settingUp": "आपका डैशबोर्ड तैयार हो रहा है…",
    "plan.saveChanges": "बदलाव सेव करें",
    "plan.saving": "सेव हो रहा है…",
    "coach.online": "ऑनलाइन",
    "coach.placeholder": "अपने कोच से कुछ भी पूछें…",
    "coach.history": "चैट इतिहास",
  },
  zh: {
    "tab.analyze": "分析",
    "tab.log": "记录",
    "tab.progress": "进度",
    "tab.coach": "教练",
    "tab.more": "更多",
    "common.continue": "继续",
    "common.back": "返回",
    "common.save": "保存",
    "common.cancel": "取消",
    "common.done": "完成",
    "common.loading": "加载中…",
    "common.signOut": "退出登录",
    "more.account": "账户",
    "more.app": "应用",
    "more.features": "功能",
    "more.myProfile": "我的资料",
    "more.editGoals": "编辑目标",
    "more.chatCoach": "与 Bitelyze 教练聊天",
    "more.appearance": "外观",
    "more.notifications": "通知",
    "more.homeScreen": "添加到主屏幕",
    "more.language": "语言",
    "more.languageDesc": "选择您偏好的语言。AI 教练将以您选择的语言回复。",
    "plan.startTracking": "开始追踪",
    "plan.settingUp": "正在准备您的仪表板…",
    "plan.saveChanges": "保存更改",
    "plan.saving": "正在保存…",
    "coach.online": "在线",
    "coach.placeholder": "向您的教练提问…",
    "coach.history": "聊天历史",
  },
  ja: {
    "tab.analyze": "分析",
    "tab.log": "記録",
    "tab.progress": "進捗",
    "tab.coach": "コーチ",
    "tab.more": "その他",
    "common.continue": "続ける",
    "common.back": "戻る",
    "common.save": "保存",
    "common.cancel": "キャンセル",
    "common.done": "完了",
    "common.loading": "読み込み中…",
    "common.signOut": "ログアウト",
    "more.account": "アカウント",
    "more.app": "アプリ",
    "more.features": "機能",
    "more.myProfile": "マイプロフィール",
    "more.editGoals": "目標を編集",
    "more.chatCoach": "Bitelyze コーチとチャット",
    "more.appearance": "外観",
    "more.notifications": "通知",
    "more.homeScreen": "ホーム画面に追加",
    "more.language": "言語",
    "more.languageDesc": "希望の言語を選んでください。AI コーチは選ばれた言語で返答します。",
    "plan.startTracking": "トラッキング開始",
    "plan.settingUp": "ダッシュボードを準備中…",
    "plan.saveChanges": "変更を保存",
    "plan.saving": "保存中…",
    "coach.online": "オンライン",
    "coach.placeholder": "コーチに質問してみよう…",
    "coach.history": "チャット履歴",
  },
  ko: {
    "tab.analyze": "분석",
    "tab.log": "기록",
    "tab.progress": "진행 상황",
    "tab.coach": "코치",
    "tab.more": "더 보기",
    "common.continue": "계속",
    "common.back": "뒤로",
    "common.save": "저장",
    "common.cancel": "취소",
    "common.done": "완료",
    "common.loading": "로딩 중…",
    "common.signOut": "로그아웃",
    "more.account": "계정",
    "more.app": "앱",
    "more.features": "기능",
    "more.myProfile": "내 프로필",
    "more.editGoals": "목표 수정",
    "more.chatCoach": "Bitelyze 코치와 채팅",
    "more.appearance": "테마",
    "more.notifications": "알림",
    "more.homeScreen": "홈 화면에 추가",
    "more.language": "언어",
    "more.languageDesc": "원하는 언어를 선택하세요. AI 코치는 선택한 언어로 답변합니다.",
    "plan.startTracking": "추적 시작",
    "plan.settingUp": "대시보드 준비 중…",
    "plan.saveChanges": "변경사항 저장",
    "plan.saving": "저장 중…",
    "coach.online": "온라인",
    "coach.placeholder": "코치에게 무엇이든 물어보세요…",
    "coach.history": "채팅 기록",
  },
  id: {
    "tab.analyze": "Analisis",
    "tab.log": "Catatan",
    "tab.progress": "Kemajuan",
    "tab.coach": "Pelatih",
    "tab.more": "Lainnya",
    "common.continue": "Lanjutkan",
    "common.back": "Kembali",
    "common.save": "Simpan",
    "common.cancel": "Batal",
    "common.done": "Selesai",
    "common.loading": "Memuat…",
    "common.signOut": "Keluar",
    "more.account": "Akun",
    "more.app": "Aplikasi",
    "more.features": "Fitur",
    "more.myProfile": "Profil saya",
    "more.editGoals": "Edit tujuan",
    "more.chatCoach": "Chat dengan Bitelyze",
    "more.appearance": "Tampilan",
    "more.notifications": "Notifikasi",
    "more.homeScreen": "Tambahkan ke layar utama",
    "more.language": "Bahasa",
    "more.languageDesc": "Pilih bahasa pilihan Anda. Pelatih AI akan membalas dalam bahasa yang dipilih.",
    "plan.startTracking": "Mulai melacak",
    "plan.settingUp": "Menyiapkan dasbor Anda…",
    "plan.saveChanges": "Simpan perubahan",
    "plan.saving": "Menyimpan…",
    "coach.online": "Online",
    "coach.placeholder": "Tanyakan apa saja ke pelatih Anda…",
    "coach.history": "Riwayat obrolan",
  },
  tl: {
    "tab.analyze": "Suriin",
    "tab.log": "Talaan",
    "tab.progress": "Pag-unlad",
    "tab.coach": "Tagapagsanay",
    "tab.more": "Higit pa",
    "common.continue": "Magpatuloy",
    "common.back": "Bumalik",
    "common.save": "I-save",
    "common.cancel": "Kanselahin",
    "common.done": "Tapos na",
    "common.loading": "Naglo-load…",
    "common.signOut": "Mag-sign out",
    "more.account": "Account",
    "more.app": "App",
    "more.features": "Mga tampok",
    "more.myProfile": "Aking profile",
    "more.editGoals": "I-edit ang mga layunin",
    "more.chatCoach": "Mag-chat sa Bitelyze",
    "more.appearance": "Hitsura",
    "more.notifications": "Mga abiso",
    "more.homeScreen": "Idagdag sa Home Screen",
    "more.language": "Wika",
    "more.languageDesc": "Pumili ng iyong gustong wika. Sasagutin ka ng AI coach sa wikang napili mo.",
    "plan.startTracking": "Simulan ang pag-track",
    "plan.settingUp": "Inihahanda ang iyong dashboard…",
    "plan.saveChanges": "I-save ang mga pagbabago",
    "plan.saving": "Sini-save…",
    "coach.online": "Naka-online",
    "coach.placeholder": "Magtanong sa iyong coach…",
    "coach.history": "Kasaysayan ng chat",
  },
  sw: {
    "tab.analyze": "Changanua",
    "tab.log": "Kumbukumbu",
    "tab.progress": "Maendeleo",
    "tab.coach": "Mkocha",
    "tab.more": "Zaidi",
    "common.continue": "Endelea",
    "common.back": "Rudi",
    "common.save": "Hifadhi",
    "common.cancel": "Ghairi",
    "common.done": "Imekamilika",
    "common.loading": "Inapakia…",
    "common.signOut": "Ondoka",
    "more.account": "Akaunti",
    "more.app": "Programu",
    "more.features": "Vipengele",
    "more.myProfile": "Wasifu wangu",
    "more.editGoals": "Hariri malengo",
    "more.chatCoach": "Zungumza na Bitelyze",
    "more.appearance": "Mwonekano",
    "more.notifications": "Arifa",
    "more.homeScreen": "Ongeza kwenye skrini ya nyumbani",
    "more.language": "Lugha",
    "more.languageDesc": "Chagua lugha unayopendelea. Mkocha wa AI atajibu kwa lugha uliyochagua.",
    "plan.startTracking": "Anza kufuatilia",
    "plan.settingUp": "Inaandaa dashibodi yako…",
    "plan.saveChanges": "Hifadhi mabadiliko",
    "plan.saving": "Inahifadhi…",
    "coach.online": "Mtandaoni",
    "coach.placeholder": "Muulize mkocha wako chochote…",
    "coach.history": "Historia ya mazungumzo",
  },
  yo: {
    "tab.analyze": "Ṣàyẹ̀wò",
    "tab.log": "Àkọsílẹ̀",
    "tab.progress": "Ìlọsíwájú",
    "tab.coach": "Olùkọ́",
    "tab.more": "Síwájú",
    "common.continue": "Tẹ̀síwájú",
    "common.back": "Padà",
    "common.save": "Pamọ́",
    "common.cancel": "Fagilé",
    "common.done": "Tán",
    "common.loading": "Ń ṣe ìṣàmúṣe…",
    "common.signOut": "Jáde",
    "more.account": "Àkántì",
    "more.app": "Ohun-èlò",
    "more.features": "Ànfàní",
    "more.myProfile": "Ìròyìn mi",
    "more.editGoals": "Ṣàtúnṣe ibi-èrè",
    "more.chatCoach": "Bá Bitelyze sọ̀rọ̀",
    "more.appearance": "Ìfarahàn",
    "more.notifications": "Ìfitónilétí",
    "more.homeScreen": "Fi sí ojú-ìwé ilé",
    "more.language": "Èdè",
    "more.languageDesc": "Yan èdè tí o fẹ́ràn. Olùkọ́ AI yóò dáhùn ní èdè tí o yàn.",
    "plan.startTracking": "Bẹ̀rẹ̀ àfojúsùn",
    "plan.settingUp": "Ń múra páànù rẹ sílẹ̀…",
    "plan.saveChanges": "Pa àwọn ìyípadà mọ́",
    "plan.saving": "Ń pa mọ́…",
    "coach.online": "Ó wà lórí ayélujára",
    "coach.placeholder": "Bí olùkọ́ rẹ ní ohunkóhun…",
    "coach.history": "Ìtàn ìfọ̀rọ̀wérọ̀",
  },
  ig: {
    "tab.analyze": "Nyochaa",
    "tab.log": "Ndekọ",
    "tab.progress": "Ọganihu",
    "tab.coach": "Onye nkuzi",
    "tab.more": "Ọzọ",
    "common.continue": "Gaa n'ihu",
    "common.back": "Laghachi",
    "common.save": "Chekwaa",
    "common.cancel": "Kagbuo",
    "common.done": "Emechara",
    "common.loading": "Na-ebu…",
    "common.signOut": "Pụọ",
    "more.account": "Akaụntụ",
    "more.app": "Ngwa",
    "more.features": "Atụmatụ",
    "more.myProfile": "Profaịlụ m",
    "more.editGoals": "Dezie ebumnobi",
    "more.chatCoach": "Soro Bitelyze kparịta ụka",
    "more.appearance": "Ọdịdị",
    "more.notifications": "Ọkwa",
    "more.homeScreen": "Tinye n'ihu mbido",
    "more.language": "Asụsụ",
    "more.languageDesc": "Họrọ asụsụ ị masịrị. Onye nkuzi AI ga-aza n'asụsụ ị họrọrọ.",
    "plan.startTracking": "Bido nleba anya",
    "plan.settingUp": "Na-akwado dashboard gị…",
    "plan.saveChanges": "Chekwaa mgbanwe",
    "plan.saving": "Na-echekwa…",
    "coach.online": "Nọ n'ịntanetị",
    "coach.placeholder": "Jụọ onye nkuzi gị ihe ọ bụla…",
    "coach.history": "Akụkọ mkparịta ụka",
  },
  ha: {
    "tab.analyze": "Bincika",
    "tab.log": "Tarihi",
    "tab.progress": "Ci gaba",
    "tab.coach": "Mai horarwa",
    "tab.more": "Ƙari",
    "common.continue": "Ci gaba",
    "common.back": "Koma",
    "common.save": "Ajiye",
    "common.cancel": "Soke",
    "common.done": "An gama",
    "common.loading": "Ana lodawa…",
    "common.signOut": "Fita",
    "more.account": "Asusu",
    "more.app": "Manhaja",
    "more.features": "Fasaloli",
    "more.myProfile": "Bayanaina",
    "more.editGoals": "Gyara manufofi",
    "more.chatCoach": "Yi hira da Bitelyze",
    "more.appearance": "Bayyanar",
    "more.notifications": "Sanarwa",
    "more.homeScreen": "Ƙara zuwa allon gida",
    "more.language": "Harshe",
    "more.languageDesc": "Zaɓi harshen da ka fi so. Mai horarwa na AI zai amsa da harshen da ka zaɓa.",
    "plan.startTracking": "Fara bibiya",
    "plan.settingUp": "Ana shirya dashboard ɗinka…",
    "plan.saveChanges": "Ajiye canje-canje",
    "plan.saving": "Ana ajiyewa…",
    "coach.online": "Akan layi",
    "coach.placeholder": "Tambayi mai horarwa wani abu…",
    "coach.history": "Tarihin tattaunawa",
  },
};

const DEFAULT_LANG = "en";

export function getStoredLang() {
  try {
    const v = localStorage.getItem("bitelyze_lang");
    if (v && STRINGS[v]) return v;
    if (v && LANGUAGES.find(l => l.code === v)) return v; // valid code, no full translation yet
  } catch (e) {}
  return DEFAULT_LANG;
}

export function setStoredLang(code) {
  try { localStorage.setItem("bitelyze_lang", code); } catch (e) {}
}

// Translate a single key. Falls back to English, then to the key itself.
export function translate(key, lang) {
  const dict = STRINGS[lang] || STRINGS[DEFAULT_LANG];
  if (dict && dict[key]) return dict[key];
  if (STRINGS[DEFAULT_LANG][key]) return STRINGS[DEFAULT_LANG][key];
  return key;
}

// Helper that returns a t(key) function bound to a language.
export function makeT(lang) {
  return (key) => translate(key, lang);
}
